import React from "react";

const StatusText = ({ status, ...props }) => {
  let statusText = "";

  switch (status) {
    case "connected":
      statusText = "Conectado - WhatsApp vinculado com sucesso.";
      break;
    case "disconnected":
      statusText = "Desconectado – Conexão perdida ou expirada.";
      break;
    default:
      statusText = "Aguardando conexão - QR Code gerado!";
      break;
  }
  return (
    <div
      style={{
        marginLeft: 8,
        fontSize: 12,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 8,
        paddingTop: 8,
        borderRadius: 8,
        background: "#F5F5F5",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div style={{ textOverflow: "ellipsis", overflow: "hidden" }}></div>
      {statusText}
    </div>
  );
};

export default StatusText;
